import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getHomeSectionTarget, scrollToHomeSection } from '../utils/scrollToHomeSection';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    const sectionTarget = getHomeSectionTarget(location);

    if (sectionTarget) {
      const timer = window.setTimeout(() => {
        scrollToHomeSection(sectionTarget);
      }, 100);

      return () => window.clearTimeout(timer);
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [location]);

  return null;
};

export default ScrollToTop;
